import React from "react";
import { BreathingSprite } from "./BreathingSprite";
import { enemySpriteUrl } from "../../utils/enemySprites";

export const EnemySprite = ({ enemyId, alt = "", className = "", testId = "enemy-sprite", facingLeft = false }) => {
  const url = enemySpriteUrl(enemyId);
  if (!url) return null;
  return <BreathingSprite src={url} alt={alt} className={className} testId={testId} facingLeft={facingLeft} />;
};
